﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const OperationalContextClient_1 = require("./swagger/OperationalContextClient");
class VehicleSharingClient {
    constructor() {
        this.client = new OperationalContextClient_1.OperationalContextClient();
    }
    add(vehicleSharing) {
        return this.client.apiVehiclesharingPost(vehicleSharing);
    }
    delete(vehicleSharing) {
        return this.client.apiVehiclesharingDelete(vehicleSharing);
    }
    loadAll() {
        return this.client.apiVehiclesharingGet();
    }
}
exports.VehicleSharingClient = VehicleSharingClient;
//# sourceMappingURL=VehicleSharingClient.js.map